<template>
  <footer
    v-if="store.showFooter"
    id="footer"
    ref="footerRef"
    class="relative z-[9] overflow-hidden px-4 lg:px-8"
    :class="store.simpleFooter ? 'bg-gradient-primary bg-grey-dark pt-8' : 'bg-grey'"
  >
    <div class="flex h-full flex-col justify-between pt-4 lg:min-h-screen lg:gap-20 lg:pt-8">
      <div class="grid-default gap-y-0">
        <div class="col-span-8 self-center lg:col-span-4">
          <Button
            v-for="(item, idx) in data.allMenuCtas"
            :key="idx"
            class="w-fit"
            :label="item.title"
            :to="
              item.reference
                ? (useLocalePathByType(
                    item!.reference._modelApiKey,
                    item.reference.slug as string
                  ) as string)
                : (item.externalLink as string)
            "
            :target="item.externalLink && '_blank'"
            :variant="item.primary ? 'solid' : 'outline'"
            icon="custom:chevron-right"
          />
        </div>
        <Logo
          class="col-span-4 h-auto w-16 justify-self-end text-black lg:col-span-4 lg:w-20 lg:self-center lg:justify-self-center"
          :class="
            isVisible && 'rotate-[360deg] transition-transform delay-300 duration-1000 ease-out'
          "
        />
        <SocialLinks
          class="col-span-full mt-10 lg:col-span-4 lg:mt-0 lg:self-center lg:justify-self-end"
          :data="data.allSocialLinks"
        />
      </div>
      <div>
        <div class="grid-default gap-y-0">
          <div
            class="col-span-full mt-20 max-w-[564px] text-base uppercase text-black lg:col-span-5 lg:mt-0"
          >
            <p>
              Pakt Media is a film & TV production company specialized in servicing high-end
              productions in the Alpe-Adria region.
            </p>
            <div class="mt-8 flex gap-4 lg:mt-12">
              <div class="flex flex-1 flex-col gap-6">
                <span>Croatia</span>
                <address class="flex flex-col not-italic">
                  <span>Savska cesta 118</span><span>10000 Zagreb</span><span>Croatia</span>
                </address>
              </div>
              <div class="flex flex-1 flex-col gap-6">
                <span>Slovenia</span>
                <address class="flex flex-col not-italic">
                  <span>Prešernov trg 1</span><span>1000 Ljubljana</span><span>Slovenia</span>
                </address>
              </div>
            </div>
          </div>
          <div class="col-span-full mt-20 lg:mt-0">
            <FooterLinks :data="data.allFooterLinks" />
          </div>
        </div>
        <div class="col-span-full -mb-[3%] pt-2 lg:pt-10">
          <Image
            :src="footerLogo"
            class="w-full"
            :width="1374"
            :height="174"
            alt="Pakt Media Logo"
          />
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import type { AppState } from '~/stores/AppStore'
import { useIntersectionObserver } from '@vueuse/core'

import footerLogo from '~/assets/images/ui/footer-logo.webp'

defineProps({
  data: {
    type: Object as PropType<AppState>,
    default: () => {}
  }
})

const store = useAppStore()
const footerRef = ref<HTMLElement | null>(null)
const isVisible = ref(false)

const { stop } = useIntersectionObserver(
  footerRef,
  ([entry], _observerElement) => {
    // if (entry?.isIntersecting && !isVisible.value) {
    //   isVisible.value = true
    // }
    isVisible.value = entry?.isIntersecting
  },
  { threshold: 0.3 }
)

onUnmounted(() => {
  stop()
})
</script>
